/**
 * Created by claudio iozzia on 07/04/2017.
 */

import {Ic} from "../common";
import {IAppSpec} from "../../Redux/selector.state";
import {ISingleOutput} from "../ISpec";

export type IAcceptorFn<T, U> = (value: T, spec: U) => boolean;
export type IAcceptorOutputFn<T, U, V, X> = (value: T, spec: U, out: V, i: X) => boolean;

export type AcceptorFn = IAcceptorFn<Ic, IAppSpec>;
export type AcceptorOutputFn = IAcceptorOutputFn<Ic, IAppSpec, ISingleOutput<number>, number>;

export type AcceptorCreator = (a: Ic) => IAcceptor;

export function andAcceptor<T, U>(acceptors: IAcceptorFn<T, U>[]): IAcceptorFn<T, U> {
  return (t, u) => acceptors.reduce((acc, p) => acc ? p(t, u) : acc, true);
}

export function andAcceptorSingle<T, U, V, X>(acceptors: IAcceptorOutputFn<T, U, V, X>[]): IAcceptorOutputFn<T, U, V, X> {
  return (t, u, v, x) => acceptors.reduce((acc, p) => acc ? p(t, u, v, x) : acc, true);
}

export const acceptAll: AcceptorFn = (a: Ic, spec: IAppSpec): boolean => {
  return true;
};

export const acceptAllOutput: AcceptorOutputFn = (a: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
  return true;
};

export interface IAcceptor {
  accept: AcceptorFn;
}

export class Acceptor implements IAcceptor {

  public static createAcceptor(a: Ic): IAcceptor { return new Acceptor();}

  protected get status(): AcceptorFn { return acceptAll; }
  protected get inputMin(): AcceptorFn { return acceptAll; }
  protected get inputMax(): AcceptorFn { return acceptAll; }
  protected get numberOutputs(): AcceptorFn { return acceptAll; }
  protected get numberLeds(): AcceptorFn { return acceptAll; }
  protected get output(): AcceptorFn { return acceptAll; }
  protected get features(): AcceptorFn { return acceptAll; }

  accept = andAcceptor([this.status, this.numberLeds, this.inputMin, this.inputMax, this.numberOutputs, this.output, this.features]);
}
